export const ADDITIONAL_PHONE_FIELD_NAME = 'Mobile number';
export const REFERENCE_CONTACT_NUMBER_FIELD_NAME = 'Reference’s mobile number';
export const REFERENCE_NAME_FIELD_NAME = 'Name of the reference';
export const RELATIONSHIP_FIELD_NAME = 'Relationship';
export const FAMILY_RELATION_FIELD_NAME = 'Relation';
